import $ from "jquery";

export default class Side {

  public body : HTMLElement;

  constructor() {
    this.body = document.querySelector('body') as HTMLElement;

    if($('.js-side').length > 0){
      $(window).on('scroll resize', this.check_side);
    }

  }

  check_side() {
    var window_height = $(window).height() as number;
    var window_top_position = $(window).scrollTop() as number;
  
    var $element = $('.js-side');
    var $sidemenu = $('.js-sidemenu');
    var element_height = $element.outerHeight() as number;
    var element_top_position = 0;
    element_top_position = $sidemenu.offset()?.top as number;
  
    //check to see if this current container is within viewport
    if ( (element_top_position - 130 <= window_top_position)) {
      $sidemenu.find('.side__table').addClass('is-fixed');
    } else {
      $sidemenu.find('.side__table').removeClass('is-fixed');
    }

  }

}

